module.exports = __webpack_public_path__ + "img/nodeType5.42b3743b.svg";